import { Box } from "@mui/material";
import { useEffect } from "react";
import ChangeOrderModal from "../../components/ChangeOrderModal";

export const ReviseMRQTable = ({
  plant,
  data,
  mrqDetails,
  mrqMaterials,
  setMrqMaterials,
}) => {
  useEffect(() => {
    const revisedMaterials = data
      .map((row) => {
        const leftMaterial = row.left?.mrqMaterials?.[0];
        const rightMaterial = row.right;

        if (leftMaterial) {
          return {
            ...leftMaterial,
            materials: rightMaterial?.materials || [],
            procuredQty: rightMaterial?.quantity || "",
            length: rightMaterial?.length || "",
          };
        }

        return null;
      })
      .filter(Boolean);

    setMrqMaterials(revisedMaterials);
  }, [data, setMrqMaterials]);

  const consolidatedMaterials = [];

  return (
    <Box>
      <ChangeOrderModal
        plant={plant}
        mrqDetails={mrqDetails}
        drawing={{}}
        consolidatedMaterials={consolidatedMaterials}
        mrqMaterials={mrqMaterials}
        setMrqMaterials={setMrqMaterials}
        type="revise"
      />
    </Box>
  );
};
